@import "../../../../../shared/styles/base";

.c-select {
  position: relative;

  &.is-horizontal {
    display: flex;
    align-items: center;
  }

  &.is-horizontal &__label {
    margin: 0;
    margin-right: 0.5rem;
  }

  &.is-horizontal + .c-select.is-horizontal {
    margin-left: 1rem;
  }

  &__wrapper {
    position: relative;
  }

  &__input {
    display: block;
    width: 100%;
    height: 3rem;
    border: 1px solid $ds-neutral-200;
    background: $white;
    border-radius: 0.25rem;
    font-size: $ds-font-size-b1;
    padding: 0 2.5rem 0 1rem;
    appearance: none;
    color: $ds-violet-900;
  }

  &.is-medium &__input {
    height: 2.5rem;
  }

  &.is-small &__input {
    height: 2rem;
  }

  &__icon {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &__pre-icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &.is-medium &__pre-icon {
    left: 0.75rem;
  }

  &.is-small &__pre-icon {
    left: 0.5rem;
  }

  &__pre-icon + &__input {
    padding-left: 3rem;
  }

  &.is-medium &__pre-icon + &__input {
    padding-left: 2.5rem;
  }

  &.is-small &__pre-icon + &__input {
    padding-left: 2rem;
  }

  & .is-ghost {
    border: 1px solid transparent;

    &:hover {
      background-color: $ds-neutral-50;
    }
  }
}
